import React from 'react';
import PropTypes from 'prop-types';
import { StyledLabel } from './styled';

const FormLabel = ({ children, htmlFor, customStyle }) => {
    return (
        <StyledLabel
            htmlFor={htmlFor}
            customStyle={customStyle}
        >
            {children}
        </StyledLabel>
    );
};

FormLabel.propTypes = {
    children: PropTypes.node,
    htmlFor: PropTypes.string,
    customStyle: PropTypes.array
};

FormLabel.defaultProps = {};

export default React.memo(FormLabel);
